<template>
  <div class="ma-2">
    <v-card-title>
       {{ rota.description }}
    </v-card-title>

    <v-divider/>
    <v-row dense>
      <v-col cols="5" v-show="dataExtensions" class="mr-4">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataExtensions"
          :items-per-page.sync="itemsPerPage"
          :page="pageExtensions"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-data-table
              :headers="extensionsHeader"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Ramais:
                  {{ dataExtensions ? dataExtensions.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageExtensions"
                  :numberOfPages="numberOfPagesExtensions"
                  @firstPage="firstPageExtensions"
                  @formerPage="formerPageExtensions"
                  @nextPage="nextPageExtensions"
                  @lastPage="lastPageExtensions"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>

      <v-col cols="5" v-show="dataTrunks" class="mr-4">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataTrunks"
          :items-per-page.sync="itemsPerPage"
          :page="pageTrunks"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-data-table
              :headers="trunksHeader"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Troncos:
                  {{ dataTrunks ? dataTrunks.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageTrunks"
                  :numberOfPages="numberOfPagesTrunks"
                  @firstPage="firstPageTrunks"
                  @formerPage="formerPageTrunks"
                  @nextPage="nextPageTrunks"
                  @lastPage="lastPageTrunks"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>   

      <v-col cols="5" v-show="dataUras" class="mr-4">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataUras"
          :items-per-page.sync="itemsPerPage"
          :page="pageUras"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-data-table
              :headers="urasHeader"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Uras:
                  {{ dataUras ? dataUras.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageUras"
                  :numberOfPages="numberOfPagesUras"
                  @firstPage="firstPageUras"
                  @formerPage="formerPageUras"
                  @nextPage="nextPageUras"
                  @lastPage="lastPageUras"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>

      <v-col cols="5" v-show="dataTasks" class="mr-4">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataTasks"
          :items-per-page.sync="itemsPerPage"
          :page="pageTasks"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-data-table
              :headers="tasksHeader"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Tarefas:
                  {{ dataTasks ? dataTasks.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageTasks"
                  :numberOfPages="numberOfPagesTasks"
                  @firstPage="firstPageTasks"
                  @formerPage="formerPageTasks"
                  @nextPage="nextPageTasks"
                  @lastPage="lastPageTasks"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col> 

     <v-col cols="5" v-show="dataOperators">
       <v-data-iterator
          :no-data-text="noDataText"
          :items="dataOperators"
          :items-per-page.sync="itemsPerPage"
          :page="pageOperators"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
          <v-data-table
            :headers="operatorsHeader"
            :items="props.items"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1"
          >
          </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Operadores:
                  {{ dataOperators ? dataOperators.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageOperators"
                  :numberOfPages="numberOfPagesOperators"
                  @firstPage="firstPageOperators"
                  @formerPage="formerPageOperators"
                  @nextPage="nextPageOperators"
                  @lastPage="lastPageOperators"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col> 

      <v-col cols="5" v-show="dataWebHooks" class="mr-4">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataWebHooks"
          :items-per-page.sync="itemsPerPage"
          :page="pageWebHooks"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-data-table
              :headers="WebHooksHeader"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de WebHooks:
                  {{ dataWebHooks ? dataWebHooks.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageWebHooks"
                  :numberOfPages="numberOfPagesWebHooks"
                  @firstPage="firstPageWebHooks"
                  @formerPage="formerPageWebHooks"
                  @nextPage="nextPageWebHooks"
                  @lastPage="lastPageWebHooks"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col> 
    </v-row>  
      
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import ListPagination from '@/componentes/ListPagination'
import rotasStore from '../_store'

export default {
  components: { ListPagination },
  name: 'UseOfRoutesDialog',
  props: {
    rota: Object,
  },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    extensionsHeader: [
        {
          text: 'Ramal',
          value: 'extension',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Nome',
          value: 'name',
          align: 'left',
        },
    ],
    trunksHeader: [
      {
          text: 'Tronco',
          value: 'description',
          align: 'left',
          width: '50%',
      },
    ],
    urasHeader: [
      {
          text: 'Ura',
          value: 'description',
          align: 'left',
          width: '50%',
      },
    ],
    tasksHeader: [
      {
          text: 'Tarefa',
          value: 'task',
          align: 'left',
          width: '50%',
      },
      {
          text: 'Ação da Rota',
          value: 'action',
          align: 'left',
      },
    ],
    operatorsHeader: [
        {
          text: 'Operador',
          value: 'agentNumber',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Nome',
          value: 'agentName',
          align: 'left',
        },
    ],
    webHooksHeader: [
      {
          text: 'WebHook',
          value: 'description',
          align: 'left',
          width: '50%',
      },
    ],
    itemsPerPage: 5,
    pageExtensions: 1,
    pageTrunks: 1,
    pageUras: 1,
    pageTasks: 1,
    pageOperators: 1,
    pageWebHooks: 1,
    dataExtensions: [],
    dataTrunks: [],
    dataUras: [],
    dataTasks: [],
    dataOperators: [],
    dataWebHooks: [],
  }),
  async created() {
    registerVuexModule(this.$store, 'rotasHomeModulePABXStore', rotasStore)
  },
  computed: {
    ...mapGetters('rotasHomeModulePABXStore', ['getRotaUse']),
    numberOfPagesExtensions() {
      if(this.dataExtensions){
       return Math.ceil(this.dataExtensions.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesTrunks() {
      if(this.dataTrunks){
       return Math.ceil(this.dataTrunks.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesUras() {
      if(this.dataUras){
       return Math.ceil(this.dataUras.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesTasks() {
      if(this.dataTasks){
       return Math.ceil(this.dataTasks.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesOperators() {
      if(this.dataOperators){
       return Math.ceil(this.dataOperators.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesWebHooks() {
      if(this.dataWebHooks){
       return Math.ceil(this.dataWebHooks.length / this.itemsPerPage)
      }
      return 0;
    },
  },
  methods: {
    firstPageExtensions() {
      if (this.pageExtensions > 1) {
        this.pageExtensions = 1
      }
    },
    formerPageExtensions() {
      if (this.pageExtensions > 1) {
        this.pageExtensions -= 1
      }
    },
    nextPageExtensions() {
      if (this.pageExtensions < this.numberOfPagesExtensions) {
        this.pageExtensions += 1
      }
    },
    lastPageExtensions() {
      if (this.pageExtensions < this.numberOfPagesExtensions) {
        this.pageExtensions = this.numberOfPagesExtensions
      }
    },
    firstPageTrunks() {
      if (this.pageTrunks > 1) {
        this.pageTrunks = 1
      }
    },
    formerPageTrunks() {
      if (this.pageTrunks > 1) {
        this.pageTrunks -= 1
      }
    },
    nextPageTrunks() {
      if (this.pageTrunks < this.numberOfPagesTrunks) {
        this.pageTrunks += 1
      }
    },
    lastPageTrunks() {
      if (this.pageTrunks < this.numberOfPagesTrunks) {
        this.pageTrunks = this.numberOfPagesTrunks
      }
    },
     firstPageUras() {
      if (this.pageUras > 1) {
        this.pageUras = 1
      }
    },
    formerPageUras() {
      if (this.pageUras > 1) {
        this.pageUras -= 1
      }
    },
    nextPageUras() {
      if (this.pageUras < this.numberOfPagesUras) {
        this.pageUras += 1
      }
    },
    lastPageUras() {
      if (this.pageUras < this.numberOfPagesUras) {
        this.pageUras = this.numberOfPagesUras
      }
    },
    firstPageTasks() {
      if (this.pageTasks > 1) {
        this.pageTasks = 1
      }
    },
    formerPageTasks() {
      if (this.pageTasks > 1) {
        this.pageTasks -= 1
      }
    },
    nextPageTasks() {
      if (this.pageTasks < this.numberOfPagesTasks) {
        this.pageTasks += 1
      }
    },
    lastPageTasks() {
      if (this.pageTasks < this.numberOfPagesTasks) {
        this.pageTasks = this.numberOfPagesTasks
      }
    },
    firstPageOperators() {
      if (this.pageOperators > 1) {
        this.pageOperators = 1
      }
    },
    formerPageOperators() {
      if (this.pageOperators > 1) {
        this.pageOperators -= 1
      }
    },
    nextPageOperators() {
      if (this.pageOperators < this.numberOfPagesOperators) {
        this.pageOperators += 1
      }
    },
    lastPageOperators() {
      if (this.pageOperators < this.numberOfPagesOperators) {
        this.pageOperators = this.numberOfPagesOperators
      }
    },
     firstPageWebHooks() {
      if (this.pageWebHooks > 1) {
        this.pageWebHooks = 1
      }
    },
    formerPageWebHooks() {
      if (this.pageWebHooks > 1) {
        this.pageWebHooks -= 1
      }
    },
    nextPageWebHooks() {
      if (this.pageWebHooks < this.numberOfPagesWebHooks) {
        this.pageWebHooks += 1
      }
    },
    lastPageWebHooks() {
      if (this.pageWebHooks < this.numberOfPagesWebHooks) {
        this.pageWebHooks = this.numberOfPagesWebHooks
      }
    },
  },
  watch: {
    getRotaUse: {
      deep: true,
      immediate: true,
      handler() {
        this.dataExtensions = this.getRotaUse.extensions
        this.dataTrunks = this.getRotaUse.trunks
        this.dataUras = this.getRotaUse.uras
        this.dataTasks = this.getRotaUse.tasks
        this.dataOperators = this.getRotaUse.agents
        this.dataWebHooks = this.getRotaUse.webHooks
      },
    },
  },
}
</script>